import { render, staticRenderFns } from "./RelatorioVendasPorFormaDePagamento.vue?vue&type=template&id=9f6ca80c&"
import script from "./RelatorioVendasPorFormaDePagamento.vue?vue&type=script&lang=js&"
export * from "./RelatorioVendasPorFormaDePagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports